export default __webpack_public_path__ + "static/media/snappr_banner_desktop.690668ad.png";